<div class="auth-header">
  <img src="shared/assets/images/latch-logo.svg" alt="logo" class="logo" />
</div>

<div class="card-page">
  <latch-login loginTitle="Welcome to Latch Manager." version="{{ versionNumber }}">
  </latch-login>
</div>
